<template>
  <div class="row main-content">
    <div
      v-if="isProcessing"
      class="col text-center"
    >
      <img
        src="@/assets/img/loader.gif"
        class="mx-auto d-block center-block"
      >
    </div>
    <div
      v-else
      class="col"
    >
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('label.card.detail.cardDetails') }}
      </h1>

      <div
        v-if="responseErr"
        class="alert alert-danger text-center border-0 shadow-sm rounded-0"
      >
        <strong>
          {{ $t('error.'+`${responseErr}`) }}
        </strong>
      </div>

      <template v-if="card && hasPermission('cards:write')">
        <div
          v-if="$store.state.cards.cardDetail && $store.state.cards.cardDetail.enableActionsOnCard"
          class="card-body bg-light mb-4"
        >
          <BaseButton
            v-if="$store.state.cards.cardDetail.cardActivable"
            type="button"
            class="btn btn-primary font-inverted btn-export m-1"
            data-bs-toggle="modal"
            data-bs-target="#activateModal"
          >
            {{ $t('button.activate') }}
          </BaseButton>
          <BaseButton
            v-if="$store.state.cards.cardDetail.cardDeactivable"
            type="button"
            class="btn btn-default btn-white btn-export m-1"
            data-bs-toggle="modal"
            data-bs-target="#deactivateModal"
          >
            {{ $t('button.deactivate') }}
          </BaseButton>
          <BaseButton
            v-if="$store.state.cards.cardDetail.cardBlockable"
            type="button"
            class="btn btn-danger font-inverted btn-export m-1"
            data-bs-toggle="modal"
            data-bs-target="#blockModal"
          >
            {{ $t('button.block') }}
          </BaseButton>
          <BaseButton
            v-if="$store.state.cards.cardDetail.cardUnBlockable"
            type="button"
            class="btn btn-default btn-white btn-export m-1"
            @click-base-button-event-emitter="unblock()"
          >
            {{ $t('button.unblock') }}
          </BaseButton>
        </div>
      </template>

      <div v-if="$store.state.cards.cardDetail">
        <div
          id="accordionDetail"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingDetail"
            data-bs-toggle="collapse"
            href="#collapseDetail"
            aria-expanded="true"
            aria-controls="collapseDetail"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.card.detail.details') }}
          </div>

          <div
            id="collapseDetail"
            aria-labelledby="headingDetail"
            data-bs-parent="#accordionDetail"
            class="card-body collapse show"
          >
            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.distributor') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.distributor) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.product') }}
              </div>
              <div class="col">
                <template v-if="hasPermission('product:read')">
                  <div
                    v-if="$store.state.cards.cardDetail.product === null"
                  >
                    {{ $filters.nullFilter($store.state.cards.cardDetail.product) }}
                  </div>
                  <div
                    v-else
                    role="button"
                    class="clickable-div"
                    @click="showProduct($store.state.cards.cardDetail.product)"
                  >
                    {{ $filters.nullFilter($store.state.cards.cardDetail.product) }}
                  </div>
                </template>
                <template v-else>
                  {{ $filters.nullFilter($store.state.cards.cardDetail.product) }}
                </template>
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.beneficiary') }}
              </div>
              <div class="col">
                <div
                  role="button"
                  class="clickable-div"
                  @click="showBeneficiary($store.state.cards.cardDetail.beneficiary)"
                >
                  <template v-if="$store.state.cards.cardDetail.beneficiary">
                    {{ $filters.nullFilter($store.state.cards.cardDetail.beneficiary[0]) }}
                  </template>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.funder') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.funder) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.cardId') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.cardId) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.pan') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter(card.panCard) }}
                <template v-if="hasPermission('cards:unmaskPan')">
                  <BaseButton
                    type="button"
                    class=" "
                    data-bs-toggle="modal"
                    data-bs-target="#unmaskPanModal"
                    @click-base-button-event-emitter="unmaskPan()"
                  >
                    <svg
                      width="1.5em"
                      height="1.5em"
                      viewBox="0 0 16 16"
                      class="bi bi-eye"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                      />
                    </svg>
                  </BaseButton>
                </template>
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.cardExpiryDate') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.cardExpiryDate) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.psn') }}
              </div>
              <div class="col">
                {{ $store.state.cards.cardDetail.psn }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.cardStatus') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.cardStatus) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.logoRef') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.logoRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.activationDate') }}
              </div>
              <div class="col">
                {{ $filters.dateYYYYMMDDTiretsOrNull($store.state.cards.cardDetail.activationDate) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.activationLimitDate') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.activationLimitDate) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.artworkRef') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.artworkRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.funderName') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.funderName) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.cardStatusReason') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.cardStatusReason) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.orderRef') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.orderRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.expeditionOrderRef') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.expeditionOrderRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.orderStatus') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.orderStatus) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.issuingDate') }}
              </div>
              <div class="col">
                {{ $filters.dateYYYYMMDDTiretsOrNull($store.state.cards.cardDetail.issuingDate) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.blockingDate') }}
              </div>
              <div class="col">
                {{ $filters.dateYYYYMMDDTiretsOrNull($store.state.cards.cardDetail.blockingDate) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.lostStolenDate') }}
              </div>
              <div class="col">
                {{ $filters.dateYYYYMMDDTiretsOrNull($store.state.cards.cardDetail.lostStolenDate) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.embossingName') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.embossingName) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.packagingRef') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.packagingRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.pinTryCounter') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.pinTryCounter) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.contactLessCardInterfaceStatus') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.contactLessCardInterfaceStatus) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.cardProfileRef') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.cardProfileRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.emvProfileId') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.cards.cardDetail.emvProfileId) }}
              </div>
            </div>
            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.emvCmdList') }}
              </div>
              <div
                v-if="$store.state.cards.cardDetail.emvCommands"
                class="col"
              >
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>{{ $t('label.card.detail.emvCmdDate') }}</th>
                      <th>{{ $t('label.card.detail.emvCmdstatus') }}</th>
                      <th>{{ $t('label.card.detail.emvCmdtype') }}</th>
                      <th>{{ $t('label.card.detail.emvCmdretryCounter') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="emvCommandValue in $store.state.cards.cardDetail.emvCommands"
                      :key="emvCommandValue.id"
                    >
                      <td>{{ emvCommandValue.date }}</td>
                      <td>{{ emvCommandValue.status }}</td>
                      <td>{{ emvCommandValue.type }}</td>
                      <td>{{ emvCommandValue.retryCounter }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                v-else
                class="col"
              >
                --
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.tokenData') }}
              </div>
              <div
                v-if="$store.state.cards.cardDetail.tokenDatas"
                class="col"
              >
                <table class="table table-striped table-bordered">
                  <thead>
                  <tr>
					<th>{{ $t('label.card.detail.tokenId') }}</th>
                    <th>{{ $t('label.card.detail.consumerFacingEntityName') }}</th>
                    <th>{{ $t('label.card.detail.tokenStatus') }}</th>
                    <th>{{ $t('label.card.detail.tokenExpiryDate') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="tokenData in $store.state.cards.cardDetail.tokenDatas"
                    :key="tokenData.id"
                  >
                    <td>{{ tokenData.tokenId }}</td>
                    <td>{{ tokenData.consumerFacingEntityName }}</td>
                    <td>{{ tokenData.tokenStatus }}</td>
                    <td>{{ tokenData.tokenExpiryDate }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div
                v-else
                class="col"
              >
                --
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.cardEventList') }}
              </div>
              <div class="col">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>{{ $t('label.card.detail.cardEventType') }}</th>
                      <th>{{ $t('label.card.detail.cardEventDate') }}</th>
                      <th>{{ $t('label.card.detail.cardEventCardId') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="event in $store.state.cards.cardDetail.cardEvents"
                      :key="event.id"
                    >
                      <td>{{ $t('label.card.detail.cardEvent.'+ event.ihmName) }}</td>
                      <td>{{ $filters.dateYYYYMMDDTirets(event.eventDate) }}</td>
                      <td>{{ event.cardId }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.pKeySensitiveLabel') }}
              </div>
              <div class="col">
                <div v-if="!$store.state.cards.cardDetail.pKeySensitiveDataId">
                  --
                </div>
                <table
                  v-else
                  class="table table-striped table-bordered"
                >
                  <thead>
                    <tr>
                      <th>{{ $t('label.card.detail.pKeyCreationDate') }}</th>
                      <th>{{ $t('label.card.detail.pKeySensitiveDataId') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $filters.dateYYYYMMDDTiretsOrNull($store.state.cards.cardDetail.pKeyCreationDate) }}</td>
                      <td>{{ $filters.nullFilter($store.state.cards.cardDetail.pKeySensitiveDataId) }}</td>
                    </tr>
                    <tr
                      v-for="historyPkey in $store.state.cards.cardDetail.changePkeySensitiveDataHistoric.pkeyChanges"
                      :key="historyPkey.pKeySensitiveDataId"
                      class="mb-3"
                    >
                      <td>{{ $filters.dateYYYYMMDDTiretsOrNull(historyPkey.date) }}</td>
                      <td>{{ $filters.nullFilter(historyPkey.pKeySensitiveDataId) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div
          id="accordionCompte"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingCompte"
            data-bs-toggle="collapse"
            href="#collapseCompte"
            aria-expanded="false"
            aria-controls="collapseCompte"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.card.detail.account') }}
          </div>

          <div
            id="collapseCompte"
            aria-labelledby="headingCompte"
            data-bs-parent="#accordionCompte"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.account') }}
              </div>
              <div class="col">
                <strong>
                  <div
                    role="button"
                    class="clickable-div"
                    @click="showAccount($store.state.cards.cardDetail.account)"
                  >
                    {{ $t('label.card.detail.beneficiaryAccount') }}
                  </div>
                </strong>
              </div>
            </div>

            <div
              v-if="!$store.state.cards.cardDetail.singleFunderAccount"
              class="row"
            >
              <div class="col-2 text-end">
                {{ $t('label.card.detail.balance') }}
              </div>
              <div class="col">
                {{ $store.state.cards.cardDetail.accountBalance }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.available') }}
              </div>
              <div class="col">
                {{ $store.state.cards.cardDetail.accountAvailable }}
              </div>
            </div>
          </div>
        </div>

        <div
          id="accordionCartes"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingCartes"
            data-bs-toggle="collapse"
            href="#collapseCartes"
            aria-expanded="false"
            aria-controls="collapseCartes"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.card.detail.cards.cards') }}
          </div>

          <div
            id="collapseCartes"
            aria-labelledby="headingCartes"
            data-bs-parent="#accordionCartes"
            class="card-body collapse"
          >
            <div v-if="$store.state.cards.cardDetail.cards">
              <div
                v-for="opcCard in $store.state.cards.cardDetail.cards"
                :key="opcCard.id"
                class="border-top"
              >
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.cardId') }}
                  </div>
                  <div class="col">
                    <strong>
                      <div
                        role="button"
                        class="clickable-div"
                        @click="showCard(opcCard)"
                      >
                        {{ opcCard.cardId }}
                      </div>
                    </strong>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.cardStatus') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter(opcCard.cardStatus) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.panCard') }}
                  </div>
                  <div class="col">
                    {{ opcCard.panCard }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.psnCard') }}
                  </div>
                  <div class="col">
                    {{ opcCard.psnCard }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.expiryDate') }}
                  </div>
                  <div class="col">
                    {{ opcCard.expiryDate }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="col"
            >
              --
            </div>
          </div>
        </div>

        <div
          id="accordionCommandes"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingCommandes"
            data-bs-toggle="collapse"
            href="#collapseCommandes"
            aria-expanded="false"
            aria-controls="collapseCommandes"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.card.detail.orders.commands') }}
          </div>

          <div
            id="collapseCommandes"
            aria-labelledby="headingCommandes"
            data-bs-parent="#accordionCommandes"
            class="card-body collapse"
          >
            <div
              v-for="opcOrder in $store.state.cards.cardDetail.orders"
              :key="opcOrder.id"
              class="border-top"
            >
              <div class="row">
                <div class="col-2 text-end">
                  {{ opcOrder.orderType }}
                </div>
                <div class="col">
                  <strong>
                    <div
                      role="button"
                      class="clickable-div"
                      @click="showOrder(opcOrder)"
                    >
                      n° {{ opcOrder.orderId }}
                    </div>
                  </strong>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.card.detail.orders.expeditionRef') }}
                </div>
                <div class="col">
                  {{ opcOrder.expeditionRef }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.card.detail.orders.orderStatus') }}
                </div>
                <div class="col">
                  {{ opcOrder.orderStatus }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.card.detail.orders.documentRef') }}
                </div>
                <div class="col">
                  {{ opcOrder.documentRef }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.card.detail.orders.personalizedCardData') }}
                </div>
                <div class="col">
                  <table class="table table-striped table-bordered">
                    <tbody>
                      <tr
                        v-for="item in opcOrder.personalizedCardData"
                        :key="item.eltName"
                      >
                        <td>{{ item.eltName }}</td>
                        <td>{{ item.eltValue }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.card.detail.orders.personalizedInsetData') }}
                </div>
                <div class="col">
                  <table class="table table-striped table-bordered">
                    <tbody>
                      <tr
                        v-for="item in opcOrder.personalizedInsetData"
                        :key="item.eltName"
                      >
                        <td>{{ item.eltName }}</td>
                        <td>{{ item.eltValue }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.card.detail.orders.otherDataList') }}
                </div>
                <div class="col">
                  <table class="table table-striped table-bordered">
                    <tbody>
                      <tr
                        v-for="item in opcOrder.otherDataList"
                        :key="item.eltName"
                      >
                        <td>{{ item.eltName }}</td>
                        <td>{{ item.eltValue }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The Modal -->
    <div
      id="myModal"
      class="modal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              Modal Heading
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            Modal body..
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              data-bs-dismiss="modal"
            >
              {{ $t('button.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Activate modal validation -->
    <div
      id="activateModal"
      class="modal fade"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t('label.card.detail.modal.cardActivation') }}
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-info">
              <p>{{ $t('label.card.detail.modal.loadOption') }}</p>
            </div>

            <div class="form-group">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.card.detail.modal.cardActivation') }}
              </label>
              <div class="input-group">
                <input
                  v-model="voucherAmountValue"
                  type="number"
                  class="form-control rounded-0"
                >
                <div class="input-group-append">
                  <span class="input-group-text">
                    {{ $t('label.card.detail.modal.eur') }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.card.detail.startDate') }}
              </label>
              <div class="input-group date">
                <input
                  v-model="voucherBeginDate"
                  type="date"
                  class="form-control rounded-0"
                  placeholder="YYYY-MM-DD"
                >
                <span class="input-group-addon">
                  <i class="glyphicon glyphicon-calendar" />
                </span>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.card.detail.endDate') }}
              </label>
              <div class="input-group date">
                <input
                  v-model="voucherEndDate"
                  type="date"
                  class="form-control rounded-0"
                  placeholder="YYYY-MM-DD"
                >
                <span class="input-group-addon">
                  <i class="glyphicon glyphicon-calendar" />
                </span>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              {{ $t('button.cancel') }}
            </button>
            <BaseButton
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click-base-button-event-emitter="activate()"
            >
              {{ $t('button.activate') }}
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Deactivate modal validation -->
    <div
      id="deactivateModal"
      class="modal fade"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t('label.card.detail.modal.cardDeactivation') }}
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            />
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.card.detail.modal.reason') }}
              </label>
              <select
                v-model="deactivateReason"
                name="deactivateReason"
                class="form-control rounded-0 form-select"
              >
                <option
                  v-for="type in deactivateReasonEnum"
                  :key="type.id"
                  :value="type.value"
                >
                  {{ type.text }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              {{ $t('button.cancel') }}
            </button>
            <BaseButton
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click-base-button-event-emitter="deactivate()"
            >
              {{ $t('button.deactivate') }}
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Block modal validation -->
    <div
      id="blockModal"
      class="modal fade"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t('label.card.detail.modal.cardBlocking') }}
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.card.detail.modal.reason') }}
              </label>
              <select
                v-model="blockingReason"
                name="blockingReason"
                class="form-control rounded-0 form-select"
              >
                <option
                  v-for="type in blockReasonEnum"
                  :key="type.id"
                  :value="type.value"
                >
                  {{ type.text }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              {{ $t('button.cancel') }}
            </button>
            <BaseButton
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click-base-button-event-emitter="block()"
            >
              {{ $t('button.block') }}
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <!-- UnmaskPan modal validation -->
    <div
      id="unmaskPanModal"
      class="modal fade"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t('label.card.detail.cards.panCard') }}
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

          <div class="modal-body unselectable">
            <div class="form-group">
              <div class="col text-center">
                <img
                  v-if="pan.isPanProcessing"
                  src="@/assets/img/loader.gif"
                  class="mx-auto d-block center-block"
                >
                <h5
                  v-else
                  class="modal-title"
                >
                  <img :src="pan.panImg">
                </h5>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              {{ $t('button.ok') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <div
      id="successModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="successModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="successModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.SUCCESS_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-success">
              <p id="successModalMsg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div
      id="errorModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="errorModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="errorModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.ERROR_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <p id="errorModalMsg" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <goTopButton />
  </div>
</template>

<script src="./CardDetail.js"></script>

<style src="./CardDetail.scss" scoped lang="scss"></style>
